module.exports = __webpack_public_path__ + "img/HistoryBox.44309323.svg";